class VideoSwitcher {
  constructor() {
    // Vidéos qui doivent avoir le bouton "Complete assignment"
    const videosWithAssignment = ['Sam Villa', 'Philip Foresto'];
    const self = this;
    
    let initFunc = () => {
      const hairTypeSections = document.querySelectorAll('.hair-type-section');
      
      hairTypeSections.forEach((section) => {
        let sectionCache = {};
        
        let initSectionCache = () => {
          sectionCache.mainVideo = section.querySelector('.main-video');
          sectionCache.thumbnails = section.querySelectorAll('.thumbnail-video');
          sectionCache.videoList = section.querySelector('.list-video');
        };
        
        let registerSectionEvents = () => {
          sectionCache.thumbnails.forEach(thumbnail => {
            const oldThumbnail = thumbnail.cloneNode(true);
            if (thumbnail.parentNode) {
              thumbnail.parentNode.replaceChild(oldThumbnail, thumbnail);
            }
          });
          
          initSectionCache();
          
          sectionCache.thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', (e) => {
              e.preventDefault();
              switchSectionVideo(thumbnail);
            });
          });
        };
        
        let switchSectionVideo = (clickedThumbnail) => {
          const mainVideoData = extractVideoData(sectionCache.mainVideo);
          const clickedVideoData = extractVideoData(clickedThumbnail);
          updateMainVideo(clickedVideoData, sectionCache.mainVideo);
          updateThumbnail(clickedThumbnail, mainVideoData);
          registerSectionEvents();
        };
      
        let extractVideoData = (element) => {
          const link = element.querySelector('a').href;
          const imgSrc = element.querySelector('img').src;
          const imgAlt = element.querySelector('img').alt;
          
          const titleElement = element.querySelector('.title-3');
          const title = titleElement.childNodes[0].textContent.trim();
          const artist = titleElement.querySelector('.secondary-color').textContent.trim();
          
          const description = element.querySelector('.description').textContent.trim();
          
          let youtubeLink = link;
          if (artist.includes('Sam Villa')) {
            youtubeLink = 'https://youtu.be/rjsz2eEBP5A';
          } else if (artist.includes('Philip Foresto')) {
            youtubeLink = 'https://www.youtube.com/watch?v=hhGeVwpl_rw';
          } else if (artist.includes('James Valliant')) {
            youtubeLink = 'https://youtu.be/qCt2ysx0-5Q';
          } else if (artist.includes('Presley Poe')) {
            youtubeLink = 'https://youtu.be/f5b1G5djSbI';
          } else if (artist.includes('Javier Leon & Erica Lee Moomey')) {
            youtubeLink = 'https://youtu.be/-VdDm_lGmLY';
          }
          
          return {
            link,
            youtubeLink,
            imgSrc,
            imgAlt,
            title,
            artist,
            description
          };
        };
      
        let updateMainVideo = (videoData, mainVideoElement) => {
          mainVideoElement.querySelector('a').href = videoData.youtubeLink;
          mainVideoElement.querySelector('img').src = videoData.imgSrc;
          mainVideoElement.querySelector('img').alt = videoData.imgAlt;
          
          const titleElement = mainVideoElement.querySelector('.title-3');
          titleElement.innerHTML = '';
          titleElement.appendChild(document.createTextNode(videoData.title));
          titleElement.innerHTML += '&nbsp;';
          const artistSpan = document.createElement('span');
          artistSpan.className = 'secondary-color';
          artistSpan.textContent = videoData.artist;
          titleElement.appendChild(artistSpan);
          
          mainVideoElement.querySelector('.description').textContent = videoData.description;
          
          const shouldShowButton = videosWithAssignment.some(name => videoData.artist.includes(name));
          const isFrenchPage = window.location.pathname.includes('index-fr.html');
          
          let assignmentButton = mainVideoElement.querySelector('.btn');
          
          if (shouldShowButton) {
            if (!assignmentButton) {
              assignmentButton = document.createElement('a');
              assignmentButton.className = 'btn';
              assignmentButton.target = '_blank';
              assignmentButton.textContent = isFrenchPage ? 'Complétez le quiz' : 'Complete assignment';
              mainVideoElement.appendChild(assignmentButton);
            } else {
              assignmentButton.style.display = 'inline-block';
            }
            
            if (videoData.artist.includes('Sam Villa')) {
              assignmentButton.href = isFrenchPage ? '../game-sam/index-fr.html' : '../game-sam/index.html';
            } else if (videoData.artist.includes('Philip Foresto')) {
              assignmentButton.href = isFrenchPage ? '../game/index-fr.html' : '../game/index.html';
            }
          } else {
            if (assignmentButton) {
              assignmentButton.style.display = 'none';
            }
          }
        };
      
        let updateThumbnail = (thumbnailElement, videoData) => {
          thumbnailElement.querySelector('a').href = videoData.youtubeLink;
          
          thumbnailElement.querySelector('img').src = videoData.imgSrc;
          thumbnailElement.querySelector('img').alt = videoData.imgAlt;
          
          const titleElement = thumbnailElement.querySelector('.title-3');
          titleElement.innerHTML = '';
          titleElement.appendChild(document.createTextNode(videoData.title));
          titleElement.innerHTML += '&nbsp;';
          const artistSpan = document.createElement('span');
          artistSpan.className = 'secondary-color';
          artistSpan.textContent = videoData.artist;
          titleElement.appendChild(artistSpan);
          
          thumbnailElement.querySelector('.description').textContent = videoData.description;
        };
        
        initSectionCache();
        registerSectionEvents();
      });
    };
    
    initFunc();
  }
}

export {VideoSwitcher}
